import { ReactNode } from 'react'
import { Outlet, useParams } from 'react-router'
import { OrderContextProvider } from '../contexts/OrderContextProvider'
import AddPaymentDialog from './AddPaymentDialog'
import EditPaymentDialog from './EditPaymentDialog'
import { NotFound } from './NotFound'

export default function OrderLayout() {
  return (
    <RfqParamGuard>
      <OrderContextProvider>
        <Outlet />
        <AddPaymentDialog />
        <EditPaymentDialog />
      </OrderContextProvider>
    </RfqParamGuard>
  )
}

const RfqParamGuard = (props: { children: ReactNode }) => {
  const params = useParams<{ rfqId: string }>()
  if (!params.rfqId) {
    console.warn('RFQ ID is required')
    return <NotFound />
  }
  return <>{props.children}</>
}
